module.exports = __webpack_public_path__ + "static/gensfront-ae6b1177a7da0b7e6487799ff921e686.png";